import Reviews from './reviewsResources';
import transformError from '../shared/transformers/errorTransformer';
import transformRateSummary from './transformer/transformRateSummary';
import transformToCamelCase from '../shared/transformers/toCamelCaseTransformer';

function getReviews({ packageName, filters = {} }) {
  return Reviews.get({ packageName, ...filters })
    .then(({ body: { reviews = [], count = 0 } }) => ({
      reviews: reviews.map(transformToCamelCase),
      count,
    }))
    .catch(transformError);
}

function getRateSummary(packageName) {
  return Reviews.getRateSummary({ packageName })
    .then(({ body: { summary = {} } }) => {
      return transformRateSummary(summary);
    })
    .catch(transformError);
}

function replyToReview({ packageName, id, text }) {
  return Reviews.replyToReview({ packageName, id }, { text })
    .then(({ body: { message } = {} }) => message)
    .catch(transformError);
}

function reviewReport({ packageName, id }) {
  return Reviews.changeReviewReportStatus(
    { packageName, id },
    { report_status: true },
  )
    .then(({ body: { message } = {} }) => message)
    .catch(transformError);
}

function cancelReviewReport({ packageName, id }) {
  return Reviews.changeReviewReportStatus(
    { packageName, id },
    { report_status: false },
  )
    .then(({ body: { message } = {} }) => message)
    .catch(transformError);
}

export default {
  getReviews,
  getRateSummary,
  replyToReview,
  reviewReport,
  cancelReviewReport,
};
